var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"title":"Информация","hide-footer":!_vm.showReload},on:{"ok":_vm.onReload},scopedSlots:_vm._u([{key:"modal-footer",fn:function(ref){
var ok = ref.ok;
var cancel = ref.cancel;
return [_c('b-button',{attrs:{"variant":"primary"},on:{"click":ok}},[_vm._v("Перезагрузить сейчас")]),_c('b-button',{attrs:{"variant":"secondary"},on:{"click":cancel}},[_vm._v("Отмена")])]}}])},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.maintenanceMessage)}})])}
var staticRenderFns = []

export { render, staticRenderFns }